import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aoe-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  private startYear = 2022;
  private today = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

  get yearCopyright(): string {
    return this.startYear === this.today ? '2022' : `${this.startYear} - ${this.today}`;
  }

}
